var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#513764;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2154",
    transform: "translate(-240 -783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2188",
    className: "st0",
    d: "M270,783h40c16.6,0,30,13.4,30,30v70l0,0h-70c-16.6,0-30-13.4-30-30v-40 C240,796.4,253.4,783,270,783z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261,826.9v-0.7c0-7.9,5.7-14.7,13.5-16c5.2-0.9,10.4,0.8,14.1,4.5l1.4,1.4l1.4-1.4c3.7-3.7,8.9-5.4,14.1-4.5 c7.8,1.3,13.5,8.1,13.5,16v0.7c0,4.7-1.9,9.2-5.4,12.4l-20.5,19.1c-0.8,0.8-2,1.2-3.1,1.2s-2.3-0.4-3.1-1.2l-20.5-19.1 C262.9,836.1,261,831.6,261,826.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistPurple);
export default __webpack_public_path__ + "static/media/Wishlist_Purple.8629c6414e5b940a30cba86ce995a375.svg";
export { ForwardRef as ReactComponent };